import Help from '../Help';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "PasswordMeterHelp-root_Bq8NQ"
};
function PasswordMeter({
  warning,
  suggestions,
  ...extraProps
}) {
  const hasSuggestions = Array.isArray(suggestions) && suggestions.length >= 1;
  return /*#__PURE__*/_jsxs(Help, {
    tagName: "ul",
    className: styles.root,
    ...extraProps,
    children: [warning && /*#__PURE__*/_jsx("li", {
      children: warning
    }), suggestions && hasSuggestions && suggestions.map(suggestion => /*#__PURE__*/_jsx("li", {
      children: suggestion
    }, suggestion))]
  });
}
export default PasswordMeter;